export const movePermission = ({ data, id }) => {
  const index = data.findIndex((item) => item.id === id);

  return {
    canMoveLeft: index > 0,
    canMoveRight: index >= 0 && index < data.length - 1,
  };
};
